import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=76d240d3&scoped=true"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"
import style0 from "./messageList.vue?vue&type=style&index=0&id=76d240d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d240d3",
  null
  
)

export default component.exports